const inBrowser = typeof window !== "undefined";
function requestAniFrame() {
  if (typeof window !== "undefined") {
    const _window = window;
    return _window.requestAnimationFrame || _window.webkitRequestAnimationFrame || function(callback) {
      _window.setTimeout(callback, 1e3 / 60);
    };
  }
  return (callback) => {
    setTimeout(callback, 1e3 / 60);
  };
}
const requestAniFrame$1 = requestAniFrame();
export {
  inBrowser as i,
  requestAniFrame$1 as r
};
